export const selectNotificationEvents = (state) => state.NotificationEvents;

export const selectEventsByChannel = (state) =>
  state.NotificationEvents.get('byChannel');

export const selectEventsById = (state) => state.NotificationEvents.get('byId');
